import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-DL-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 1000 154"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-DL-logo_svg__cls-1{fill:#003d79}.svg-DL-logo_svg__cls-2{fill:#98002e}.svg-DL-logo_svg__cls-3{fill:#e31837}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "m185.7 137.6-89.3-43V0l89.3 137.6Zm7.1 16.4-96.4-40.7V154h96.4Z",
      class: "svg-DL-logo_svg__cls-2"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M7.1 137.6 96.4 0v94.6l-89.3 43M0 154h96.4v-40.7L0 154",
      class: "svg-DL-logo_svg__cls-3"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M200.6 125.8c3.5 0 6.4 2.8 6.4 6.3s-2.8 6.4-6.3 6.4-6.4-2.8-6.4-6.3c0-3.6 2.8-6.4 6.3-6.4Zm0 11.7c3 0 5.4-2.4 5.4-5.4s-2.4-5.4-5.4-5.4-5.4 2.4-5.4 5.4c0 3 2.4 5.4 5.4 5.4Zm-1.4-1.7h-.9v-7.3h2.8c1.7 0 2.3.7 2.3 2 .1 1.1-.8 2-1.8 2.1l2.2 3.2h-1l-2.2-3.2h-1.3l-.1 3.2Zm0-4.1h1.2c1 0 2.1-.1 2.1-1.3 0-.9-.9-1.2-1.6-1.2h-1.6v2.5h-.1Z",
      class: "svg-DL-logo_svg__cls-2"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M268.1 137.6h43.3c44.6 0 71.1-23.1 71.1-61.4S356 14.9 311.4 14.9h-43.3v122.7Zm27.4-101.4h15.9c28.9 0 43.4 14.3 43.4 40s-14.5 40-43.4 40h-15.9v-80ZM475.7 84.4h52.1V63.1h-52.1V36.2h58.9V14.9h-86.4v122.7h88.3v-21.3h-60.8V84.4zM692.7 116.3h-52.9V14.9h-27.5v122.7h80.4v-21.3zM840.7 14.9H730.6v21.3h41.2v101.4h27.6V36.2h41.3V14.9zM1000 137.6h-28.7l-12-30.7h-49.9l-12 30.7h-26.8l51.3-123.2h27.7l50.4 123.2Zm-48.5-51.3-17.1-43.6-17.2 43.6h34.3Z",
      class: "svg-DL-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "DL-logo"}) } }